import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

// Collection: Tabler Icons
const ApiIcon = ({
  className,
  size = 16,
  "aria-label": ariaLabel,
}: OpticksSvgElementProps) => (
  <OpticksSvgElement
    className={`icon-api${className ? ` ${className}` : ""}`}
    size={size}
    aria-label={ariaLabel}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      d="M2.66667 8.66666H6"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 10.6667V5.33334H10C10.3536 5.33334 10.6928 5.47381 10.9428 5.72386C11.1929 5.97391 11.3333 6.31305 11.3333 6.66667V7.33334C11.3333 7.68696 11.1929 8.0261 10.9428 8.27614C10.6928 8.52619 10.3536 8.66667 10 8.66667H8"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3333 5.33334V10.6667"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 10.6667V7C6 6.55798 5.82441 6.13405 5.51184 5.82149C5.19928 5.50893 4.77536 5.33334 4.33333 5.33334C3.89131 5.33334 3.46738 5.50893 3.15482 5.82149C2.84226 6.13405 2.66667 6.55798 2.66667 7V10.6667"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </OpticksSvgElement>
);

export default ApiIcon;
